module.exports = __webpack_public_path__ + "media/ai-comic.7f10b227.mp4";